import React from 'react';
import Marketplace from '@/pages/Marketplace';

const Printing3DMarketplace = () => {
  return <Marketplace discipline="3d_printing" />;
};

export default Printing3DMarketplace;
